import { render } from "./CurtainLanguageSwitcher.vue?vue&type=template&id=107ceb63"
import script from "./CurtainLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./CurtainLanguageSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script